import { State } from '../../reducer';
import { namespace } from '.';
import { createSelector } from 'reselect';

const getOrderState = (state: State) => state[namespace].order;
export const getOrder = createSelector([getOrderState], (s) => s);
const getUiStateState = (state: State) => state[namespace].state;
export const getUiState = createSelector([getUiStateState], (s) => s);
const getErrorState = (state: State) => state[namespace].error;
export const getError = createSelector([getErrorState], (s) => s);
